<template>
  <div style="height: 100%; display: flex; flex-direction: column">
    <Header style="flex-shrink: 0"></Header>
    <div style="flex-grow: 1; overflow: auto;">
      <router-view></router-view>
    </div>
    <Footer style="flex-shrink: 0"></Footer>
    <!-- <Loading v-show="isLoading" /> -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
// import Loading from '@/components/Loading.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    // Loading,
  },
  data () {
    return {

    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
